import { useState } from 'react';
import axios from 'axios';

function ImportCSV({ onImported }) {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');

  const handleUpload = async () => {
    if (!file) return;
    setStatus('Importing...');
    const formData = new FormData();
    formData.append('csv', file);
    try {
      const res = await axios.post('/api/import/csv', formData);
      const { imported, skipped } = res.data;
      setStatus(`✓ Imported ${imported} transactions${skipped > 0 ? ` · ${skipped} duplicates skipped` : ''}`);
      onImported();
    } catch (err) {
      setStatus('Error: ' + (err.response?.data?.error || err.message));
    }
  };

  const exampleRows = [
    { date: '15/01/2026', narration: 'Salary payment', debit: '', credit: '5000.00' },
    { date: '03/01/2026', narration: 'Woolworths grocery', debit: '85.50', credit: '' },
    { date: '05/01/2026', narration: 'Netflix subscription', debit: '22.99', credit: '' },
  ];

  return (
    <div className="import-wrap">
      <div className="form-title">Import CSV</div>

      {/* Example table */}
      <div style={{ marginTop: '28px' }}>
        <div style={{
          fontFamily: 'DM Mono, monospace',
          fontSize: '11px',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          color: 'var(--muted)',
          marginBottom: '12px'
        }}>
          Expected CSV Format
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr>
                {['Transaction Date', 'Narration', 'Debit', 'Credit'].map(col => (
                  <th key={col} style={{
                    fontFamily: 'DM Mono, monospace',
                    fontSize: '10px',
                    letterSpacing: '0.8px',
                    textTransform: 'uppercase',
                    color: 'var(--muted)',
                    fontWeight: '400',
                    textAlign: 'left',
                    padding: '8px 12px',
                    borderBottom: '1px solid var(--border)',
                    background: 'var(--bg)'
                  }}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {exampleRows.map((row, i) => (
                <tr key={i}>
                  <td style={{ padding: '8px 12px', fontFamily: 'DM Mono, monospace', fontSize: '12px', borderBottom: '1px solid var(--border)', color: 'var(--muted)' }}>{row.date}</td>
                  <td style={{ padding: '8px 12px', fontSize: '12px', borderBottom: '1px solid var(--border)' }}>{row.narration}</td>
                  <td style={{ padding: '8px 12px', fontFamily: 'DM Mono, monospace', fontSize: '12px', borderBottom: '1px solid var(--border)', color: 'var(--expense)' }}>{row.debit}</td>
                  <td style={{ padding: '8px 12px', fontFamily: 'DM Mono, monospace', fontSize: '12px', borderBottom: '1px solid var(--border)', color: 'var(--income)' }}>{row.credit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ fontFamily: 'DM Mono, monospace', fontSize: '11px', color: 'var(--muted)', marginTop: '8px' }}>
          Date format: DD/MM/YYYY · Debit = expense · Credit = income
        </div>
      </div>
      <div className="import-zone">
        <input type="file" accept=".csv" onChange={e => setFile(e.target.files[0])} />
        {file && <div className="import-filename">{file.name}</div>}
        <p>Export your bank statement as CSV and upload here</p>
      </div>
      <button className="btn-primary" onClick={handleUpload} disabled={!file}>Import</button>
      {status && <div className="status-msg">{status}</div>}

    </div>
  );
}

export default ImportCSV;